export default __webpack_public_path__ + "static/media/laptop15.b1b700d1.jpeg";